import { ModalityType, type Modality } from '@littlebird/sdk';

type MessageLike = {
  readonly role: 'user' | 'assistant';
  readonly modalitiesUsed: readonly Modality[] | null;
};

export type TeamChatAuthor = {
  readonly authorId: number;
  readonly authorName: string;
};

export function teamChatPostOf(message: MessageLike): TeamChatAuthor | null {
  if (message.role !== 'user') return null;
  for (const modality of message.modalitiesUsed ?? []) {
    if (modality.type === ModalityType.TeamChatPost) {
      return {
        authorId: modality.author_id,
        authorName: modality.author_name || 'Someone',
      };
    }
  }
  return null;
}

/** A post's stored text is "Name: text" and its untrusted-text note, which older apps show; newer ones show the name above the bubble */
export function postBodyOf(stored: string, authorName: string): string {
  const body = stored.split('<system>')[0].trimEnd();
  return body.startsWith(`${authorName}: `)
    ? body.slice(authorName.length + 2)
    : body;
}

export const firstNameOf = (name: string): string =>
  name.trim().split(/\s+/)[0] || name;
